// @ts-nocheck
/* eslint-disable react/prop-types */
/**
 * NodeTooltip — Tooltip wrapper for SolyticsFlow nodes.
 *
 * Uses SolyticsTooltip for plain strings. For custom ReactNode content,
 * falls back to MUI Tooltip directly because SolyticsTooltip only accepts
 * a string `text` prop and hardcodes primary-colour bubble styling.
 *
 * Supported tooltip values:
 *   • string     → SolyticsTooltip default variant
 *   • ReactNode  → zero-chrome MUI Tooltip for custom JSX content
 *   • null       → no tooltip, children rendered bare
 */
import React, { memo } from 'react';
import { Tooltip } from '@mui/material';
import SolyticsTooltip from '../../../SolyticsTooltip';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      backgroundColor: 'transparent',
      padding: 0,
      maxWidth: 'none',
      boxShadow: 'none',
    },
  },
};

const NodeTooltip = memo(({ tooltip, placement = 'bottom', children }) => {
  if (typeof tooltip === 'string') {
    return (
      <SolyticsTooltip text={tooltip} placement={placement} arrow>
        {children}
      </SolyticsTooltip>
    );
  }

  if (React.isValidElement(tooltip)) {
    return (
      <Tooltip
        title={tooltip}
        placement={placement}
        slotProps={TOOLTIP_SLOT_PROPS}
      >
        {children}
      </Tooltip>
    );
  }

  return children;
});
NodeTooltip.displayName = 'NodeTooltip';

export default NodeTooltip;
